function getSanDiegoDate() {
  const now = new Date();
  const options = { 
    timeZone: 'America/Los_Angeles', 
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false
  };
  const parts = new Intl.DateTimeFormat('en-US', options).formatToParts(now);
  const get = type => parts.find(p => p.type === type).value;
  return new Date(
    `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}:${get('second')}`
  );
}
class PdpShippingMethods extends HTMLElement {
    constructor() {
        super();
        const dataScript = this.querySelector('script[type="application/json"]');
        if (dataScript) {
            try {
                this.locationInfo = JSON.parse(dataScript.textContent);
            } catch (error) {
                console.error('Error parsing location info JSON:', error);
                this.locationInfo = null;
            }
        } else {
            this.locationInfo = null;
        }
        this.currentStoreInfo = null

        const storesDataScript = document.querySelector('script#store-metafields');
        if (storesDataScript) {
            try {
                this.storesInfo = JSON.parse(storesDataScript.textContent);
            } catch (error) {
                console.error('Error parsing stores info JSON:', error);
                this.storesInfo = null;
            }
        } else {
            this.storesInfo = null;
        }
        this.dropOffDate = ''
        this.currentStore = null;
        this.pickupAllowedStores = [];
    }

    formatDate (date) {
        const options = { weekday: 'short', month: 'short', day: '2-digit' };
        const parts = date.toLocaleDateString('en-US', options).replace(',', '').split(' ');

        return `${parts[0]}, ${parts[1]} ${parts[2]}`
    }

    _renderPopupShipFrom() {
        const shipFromDom = document.querySelector('.pdp-shipping-methods-popup .ship-form')

        if (!shipFromDom || !this.currentStoreInfo) return;

   
        const inStock = this.currentStoreInfo.regionallyAvailable === 'Y';
        if (inStock) {
            const shipFromInfoDom = shipFromDom.querySelector('[data-ship-from]');
            let shipFromStoreCode = '';
            let shipFromStoreInfoString = this.currentStoreInfo.invMessage;
            if (shipFromStoreInfoString) {
                shipFromStoreInfoString = shipFromStoreInfoString.replaceAll(' ', '');
                const shipFromStoreInfoArray = shipFromStoreInfoString.split(/(?<=\d)\s*(?=[A-Za-z])/);
                if (shipFromStoreInfoArray.length > 0) {
                    shipFromStoreInfoArray.forEach((item, index) => {
                        const [key, value] = item.split(':');
                        if (value !== '0') {
                            shipFromStoreCode = key;
                            return;
                        }
                    })
                    if (shipFromInfoDom && this.storesInfo && shipFromStoreCode) {
                        const storeInfo = this.storesInfo.find(store => store['store-cd'] === shipFromStoreCode);

                        if (storeInfo) {
                            shipFromInfoDom.textContent = `${storeInfo['city']} ${storeInfo['st']} ${storeInfo['zip-cd']}`;
                            shipFromDom.classList.remove('hidden');
                        }
                    }
                }
            }
        } else {
            shipFromDom.classList.add('hidden');
        }
    }

    async _getPickupAllowedStores() {
        // let pickupAllowedStores = this.storesInfo.filter(store => store['store-pickup-allowed'] === 'Y');
        let pickupAllowedStores = this.storesInfo.filter(store => store['store-cd'].startsWith('W'));
        if (pickupAllowedStores.length === 0) {
            return [];
        }
        pickupAllowedStores = await sortStoresByZipcode({zipCode: this.zipcode, storeList: pickupAllowedStores});

        return pickupAllowedStores;
    }

    async _renderPickupStore() {
        const popupDom = document.querySelector('.pdp-shipping-methods-popup')
        const pickupDom = popupDom.querySelector('.delivery-info-list');
        const prefix = pickupDom.getAttribute('data-prefix') || '';
        if (!pickupDom || !this.storesInfo) return;

        let pickupAllowedStores = await this._getPickupAllowedStores();

        // Render the sorted pickup allowed stores
        const firstTwoStores = pickupAllowedStores.slice(0, 1);
        pickupDom.innerHTML = firstTwoStores.map(store => `<li>${prefix}<a target="_blank" href="/pages/${this._handlizeStoreName(store['store-name'])}"> ${store['city']}, ${store['st']}</a></li>`).join('');
    }

    _handlizeStoreName(name) {
        if (!name) return '';
        let _name = name.toLowerCase();
        if(_name === 'web warehouse') {
            _name = 'miramar showroom'
        }
        return _name.replace(/\s+/g, '-');
    }

    renderPopupContent() {
        const popupDom = document.querySelector('.pdp-shipping-methods-popup')
        if (!popupDom) return;

        const zipcodeDom = popupDom.querySelector('[data-zipcode]')
        this.zipcode = getCookie('mor_zipcode')
        if (zipcodeDom) {
            zipcodeDom.textContent = this.zipcode
        }
        const todayDom = popupDom.querySelector('[data-todays-date]')
        if (todayDom) {
            todayDom.textContent = this.formatDate(getSanDiegoDate());
        }
        this._renderPopupShipFrom();
        // const dropOffDateDoms = popupDom.querySelectorAll('[data-dropoff-date]');
        // dropOffDateDoms.forEach(dropOffDateDom => {
        //     dropOffDateDom.textContent = this.dropOffDate;
        // });
        this._renderPickupStore();
        const imageDom = popupDom.querySelector('.pdp-shipping-methods-popup__product--info img');
        const currentVariantImage = document.querySelector('slider-component:not(.thumbnail-slider) .slider__slide.is-active product-modal-opener img');
        if (imageDom && currentVariantImage) {
          imageDom.src = currentVariantImage.src;
        }
    }

    async _renderStoreItem() {
        const storeTemplate = this.pickupStoreModal.querySelector('[data-store-list-item-template]');
        const storeListContainer = this.pickupStoreModal.querySelector('[data-store-list-container]');
        // let pickupAllowedStores = this.storesInfo.filter(store => store['store-pickup-allowed'] === 'Y');
        let pickupAllowedStores = this.storesInfo.filter(store => store['store-cd'].startsWith('W'));

        try {
            pickupAllowedStores = await sortStoresByZipcode({zipCode: this.zipcode, storeList: pickupAllowedStores});
        }catch(error) {
            console.error('Error sorting stores by zipcode:', error);
        }
        // Clear the existing store list
        storeListContainer.innerHTML = '';

        // Render the displayed stores
        pickupAllowedStores.forEach(store => {
            const storeItem = storeTemplate.content.cloneNode(true);
            if (store['store-cd'] === this.currentStoreCode) {
                storeItem.firstElementChild.classList.add('current-store');
            }
            storeItem.querySelector('[data-address]').textContent = store['city'] + ', ' + store['st'];
            store['distance'] 
                ? storeItem.querySelector('[data-distance]').textContent = store['distance'] 
                : storeItem.querySelector('.store-distance').classList.add('hidden');
            storeItem.querySelector('[data-zipcode]').setAttribute('data-zipcode', store['zip-cd']);
            storeItem.querySelector('[data-store-code]').setAttribute('data-store-code', store['store-cd']);
            if (store['store-cd']) {
                const firstLetterOfStoreCode = store['store-cd'].charAt(0).toUpperCase();
                storeItem.querySelector('[data-warehouse-code]').setAttribute('data-warehouse-code', 'W' + firstLetterOfStoreCode);
            }
            storeItem.querySelector('[data-store-name]').setAttribute('data-store-name', store['store-name']);
            storeListContainer.appendChild(storeItem);
        });
        console.log('4. render end')
        this.pickupStoreModalLoading(false);
    }

    renderPickupStoreList() {
        this.pickupStoreModalLoading(true);
        console.log('1. Start to render displayed store list');
        this.currentZipcode = getCookie('mor_zipcode')

        if (this.currentZipcode && this.pickupStoreModal.querySelector('[data-zipcode]')) {
            this.pickupStoreModal.querySelector('[data-zipcode]').textContent = this.currentZipcode;
        }
        this._renderStoreItem()
    }

    pickupStoreModalLoading(isLoading) {
        if (!this.pickupStoreModal) return;
        const addLoadingWrapper = this.pickupStoreModal.querySelector('.display-store-list');

        if (isLoading) {
            addLoadingWrapper.querySelector('.loading__spinner').classList.remove('hidden');
        } else {
            addLoadingWrapper.querySelector('.loading__spinner').classList.add('hidden');
        }
    }

    async connectedCallback() {
        const zipcodeDom = this.querySelector('[data-zipcode]');
        this.zipcode = getCookie('mor_zipcode')

        if (this.zipcode) {
            updatePdpShippingMethods(this.zipcode);
        }

        if (zipcodeDom) {
            zipcodeDom.addEventListener('click', () => {
                const zipcode = zipcodeDom.textContent.trim();
                const zipcodeInput = document.querySelector('change-zipcode-popup input[name="q"]');
                if (zipcodeInput) {
                    zipcodeInput.value = zipcode;
                }
            })
        }

        this.currentStoreCode = getCookie('mor_store_code');
        if (this.currentStoreCode) {
            this.currentStoreInfo = this.locationInfo[this.currentStoreCode] || null;
        }
        // if (this.currentStoreCode && this.locationInfo) {
        //     if (this.currentStoreInfo) {
        //         const invCount = Number(this.currentStoreInfo.invCount);

        //         if (!isNaN(invCount) && invCount > 0) {
        //             const now = getSanDiegoDate();
        //             const shoppingDate = now.getTime() + invCount * 24 * 60 * 60 * 1000;
        //             const shippingDateDoms = this.querySelectorAll('[data-shipping-date]');
        //             shippingDateDoms.forEach(shippingDateDom => {
        //                 if (shippingDateDom) {
        //                     const shippingDate = new Date(shoppingDate);
        //                     this.dropOffDate = this.formatDate(shippingDate);
        //                     shippingDateDom.textContent = this.dropOffDate;
        //                 }
        //             });
        //         }
        //     }
        //     console.log('Current store info:', this.currentStoreInfo);
        // }

        const popupTriggerDoms = this.querySelectorAll('.pdp-shipping-methods__option--details__title modal-opener button');
        popupTriggerDoms.forEach(trigger => {
            trigger.addEventListener('click', () => {
                this.renderPopupContent();
            });
        });

        const storeNameDom = this.querySelector('.store-name');
        if (storeNameDom) {
            this.pickupStoreModal = document.querySelector('#PopupModal-pdpShippingMethodsPickupStore');
            // storeNameDom.addEventListener('click', () => {
            //     this.renderPickupStoreList()
            // })
            if (this.storesInfo) {
                this.pickupAllowedStores = await this._getPickupAllowedStores();
                if (this.pickupAllowedStores.length !== 0) {
                    const closestToZipcodeStore = this.pickupAllowedStores[0];
                    storeNameDom.innerHTML = `<a href="/pages/${this._handlizeStoreName(closestToZipcodeStore['store-name'])}">${closestToZipcodeStore.city}, ${closestToZipcodeStore.st}</a>`;
                }
            }
        }
    }
}

customElements.define('pdp-shipping-methods', PdpShippingMethods);